import React from 'react';

export const COUNTRY_CODES = [
  { code: '+91',  country: 'IN', name: 'India',          digits: 10 },
  { code: '+1',   country: 'US', name: 'United States',  digits: 10 },
  { code: '+44',  country: 'GB', name: 'United Kingdom', digits: 10 },
  { code: '+971', country: 'AE', name: 'UAE',            digits: 9  },
  { code: '+966', country: 'SA', name: 'Saudi Arabia',   digits: 9  },
  { code: '+974', country: 'QA', name: 'Qatar',          digits: 8  },
  { code: '+968', country: 'OM', name: 'Oman',           digits: 8  },
  { code: '+965', country: 'KW', name: 'Kuwait',         digits: 8  },
  { code: '+973', country: 'BH', name: 'Bahrain',        digits: 8  },
  { code: '+92',  country: 'PK', name: 'Pakistan',       digits: 10 },
  { code: '+880', country: 'BD', name: 'Bangladesh',     digits: 10 },
  { code: '+94',  country: 'LK', name: 'Sri Lanka',      digits: 9  },
  { code: '+977', country: 'NP', name: 'Nepal',          digits: 10 },
  { code: '+60',  country: 'MY', name: 'Malaysia',       digits: 9  },
  { code: '+65',  country: 'SG', name: 'Singapore',      digits: 8  },
  { code: '+61',  country: 'AU', name: 'Australia',      digits: 9  },
  { code: '+49',  country: 'DE', name: 'Germany',        digits: 10 },
  { code: '+33',  country: 'FR', name: 'France',         digits: 9  },
  { code: '+86',  country: 'CN', name: 'China',          digits: 11 },
  { code: '+81',  country: 'JP', name: 'Japan',          digits: 10 },
];

export function getPhoneDigits(countryCode) {
  return COUNTRY_CODES.find(c => c.code === countryCode)?.digits ?? 10;
}

export default function CountryCodePicker({ value, onChange, dark = false }) {
  return (
    <select
      className={`cc-select${dark ? ' cc-select--dark' : ''}`}
      value={value}
      onChange={e => onChange(e.target.value)}
      aria-label="Country code"
    >
      {COUNTRY_CODES.map(c => (
        <option key={c.code} value={c.code}>
          {c.country} {c.code}
        </option>
      ))}
    </select>
  );
}
